import React, { useEffect, useState } from 'react'

import { animate, motion, useMotionValue, useTransform } from 'framer-motion'

const DURATION = 1.5

type Props = {
  shouldAnimate: boolean
  targetNumber: number
}

function ScoringNumber({ shouldAnimate, targetNumber = 0 }: Props) {
  const motionValue = useMotionValue(0)

  const [animated, setAnimated] = useState(false)

  const roundedValue = useTransform(motionValue, latest => Math.round(latest))

  useEffect(() => {
    if (!shouldAnimate) return

    motionValue.set(0)

    const controls = animate(motionValue, targetNumber, {
      duration: DURATION,
      ease: 'easeOut',
    })

    setAnimated(true)

    return controls.stop
  }, [targetNumber, motionValue, shouldAnimate])

  if (!shouldAnimate) return animated ? targetNumber : 0

  return <motion.div>{roundedValue}</motion.div>
}

export default ScoringNumber
